import React from 'react'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const CATEGORIES = [
  { icon: 'network', title: 'Exchange Integrations', desc: 'New exchanges added to the Arbitrade Bot\'s routing network, expanding available spreads.' },
  { icon: 'bot', title: 'Bot Improvements', desc: 'Execution speed, strategy coverage, and reliability updates to the arbitrage engine.' },
  { icon: 'layers', title: 'Dashboard Changes', desc: 'New features, redesigns, and fixes across the trading dashboard.' },
  { icon: 'shield', title: 'Security & Compliance', desc: 'Updates to account protection, regulatory registrations, and platform policies.' },
]

export default function News() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xnw-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; }
      `}</style>
      <PublicNav active="Resources" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Markets</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>News & Updates</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '560px', margin: '0 auto' }}>Release notes and platform announcements will be posted here as they happen.</p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 40px', color: C.tx }}>What Gets Posted Here</h2>
        <div className="xnw-grid">
          {CATEGORIES.map(c => (
            <div key={c.title} style={{ textAlign: 'center' }}>
              <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <Icon name={c.icon} size={36} strokeWidth={1.5} />
              </div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>{c.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light, textAlign: 'center' }}>
        <div style={{ fontSize: '14px', fontWeight: 500, color: C.tx3 }}>No announcements yet — check back soon.</div>
      </section>

      <PublicFooter />
    </div>
  )
}
